<template>
  <div>
    <h2>GPA</h2>

    <Table class="table" :columns="col1" :data="data">
      <template slot-scope="{ row }" slot="target">
        <i-input
          type="number"
          v-model="row.target"
          placeholder="请输入目标分数"
          @on-change="change($event, 'target')"
        />
      </template>
      <template slot-scope="{ row }" slot="current_grade">
        <i-input
          type="text"
          v-model="row.current_grade"
          placeholder="输入当前年级"
          @on-change="change($event, 'current_grade')"
        />
      </template>
      <template slot-scope="{ row }" slot="current_gpa">
        <i-input
          type="text"
          v-model="row.current_gpa"
          placeholder="输入目前GPA"
          @on-change="change($event, 'current_gpa')"
        />
      </template>
      <template slot-scope="{ row }" slot="weighting">
        <i-switch
          v-model="row.weighting"
          @on-change="changeSwitch"
          style="margin-right: 5px"
        />
        {{ row.weighting ? "YES" : "NO" }}
      </template>
    </Table>

    <Divider>记录</Divider>

    <Table class="table" :columns="col2" :data="recordData.list">
      <template slot-scope="{ row }" slot="index">
        {{ row._index + 1 }}
      </template>

      <template slot-scope="{ row }" slot="achievement">
        <Button type="primary" size="small" @click="openAchievement(row)"
          >查看</Button
        >
      </template>
      <template slot-scope="{ row }" slot="action">
        <Button type="primary" size="small" @click="eidt(row)">修改</Button>
      </template>
    </Table>
    <Button type="dashed" class="add-btn" @click="eidt({})">添加</Button>

    <Modal
      v-model="showEidt"
      title="记录添加/删除"
      @on-ok="save"
      @on-cancel="showEidt = false"
    >
      <Form :model="eidtObj" label-position="left" :label-width="100">
        <FormItem label="年级">
          <i-input type="text" v-model="eidtObj.grade"></i-input>
        </FormItem>
        <FormItem label="gpa分数">
          <i-input type="number" v-model="eidtObj.gpa"></i-input>
        </FormItem>
        <FormItem label="排名">
          <i-input type="text" v-model="eidtObj.rank"></i-input>
        </FormItem>
        <FormItem label="加权">
          <i-switch v-model="eidtObj.weighting" />
        </FormItem>
        <FormItem label="成绩记录">
          <uploadImg
            :key="eidtObj._id"
            :srcData="eidtObj.files"
            @uploadChange="changeFiles"
          ></uploadImg>
        </FormItem>
      </Form>
    </Modal>

    <imgsView ref="imgsView"></imgsView>
  </div>
</template>

<script>
import imgsView from "@/components/imgs-view.vue";
import uploadImg from "@/components/uploadImg.vue";
export default {
  components: {
    imgsView,
    uploadImg,
  },
  data() {
    return {
      data: [],

      col1: [
        {
          title: "目标",
          slot: "target",
          align: "center",
        },
        {
          title: "当前年级",
          slot: "current_grade",
          align: "center",
        },
        {
          title: "目前GPA",
          slot: "current_gpa",
          align: "center",
        },
        {
          title: "加权",
          slot: "weighting",
          align: "center",
        },
      ],

      col2: [
        {
          title: "序号",
          slot: "index",
          align: "center",
        },
        {
          title: "年级",
          key: "grade",
          align: "center",
        },
        {
          title: "历史GPA",
          key: "gpa",
          align: "center",
        },
        {
          title: "Rank",
          key: "rank",
          align: "center",
        },
        {
          title: "加权",
          key: "weighting",
          align: "center",
        },
        {
          title: "成绩",
          slot: "achievement",
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],

      recordData: {},

      showEidt: false,
      eidtObj: {},
      achievementObj: {},

      setTimeout: {},
    };
  },
  methods: {
    async getInfo() {
      let res = await this.api({
        url: "/gpa/getInfo",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
        },
      });

      this.data = [res];
    },

    async getData(page = 1) {
      let res = await this.api({
        url: "/gpa/select",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          page: page,
          size: 10,
        },
      });

      this.recordData = res;
    },

    eidt(val) {
      this.eidtObj = val;
      this.showEidt = true;
    },
    async save() {
      await this.api({
        url: "/gpa/save",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          ...this.eidtObj,
          student_id: this.$store.getters.selectedStudent._id,
        },
      });
      this.$Message.success("更新成功");
      this.showEidt = false;
      this.getData();
    },

    changeFiles(val) {
      this.eidtObj.files = val;
    },

    openAchievement(item) {
      let output = [];
      item.filesArr = item.files.split(";");
      item.filesArr.forEach((item) => {
        if (item) {
          output.push(item);
        }
      });
      item.filesArr = output;
      this.achievementObj = item;
      this.$refs["imgsView"].open(output);
    },

    saveTarget() {
      clearTimeout(this.setTimeout);
      this.setTimeout = setTimeout(async () => {
        await this.api({
          url: "/gpa/setTarget",
          method: "post",
          params: {
            token: this.$store.getters.token,
            ttoken: this.$store.getters.ttoken,
          },
          data: {
            type: this.selectedType,
            student_id: this.$store.getters.selectedStudent._id,
            current_grade: this.data[0].current_grade,
            current_gpa: this.data[0].current_gpa,
            weighting: this.data[0].weighting ? 1 : 0,
            target: this.data[0].target,
          },
        });
        this.$Message.success("更新成功");
        this.getInfo();
      }, 1500);
    },

    changeSwitch(val) {
      let data = this.data[0];
      data.weighting = val;
      this.$set(this.data, 0, data);
      this.saveTarget();
    },

    change(event, key) {
      console.log(event.srcElement.value);
      console.log(key);
      let data = this.data[0];
      data[key] = event.srcElement.value;
      this.$set(this.data, 0, data);
      this.saveTarget();
    },
  },
  mounted() {
    if (!this.$store.getters.selectedStudent._id) {
      return;
    }
    this.getInfo();
    this.getData();
  },
  watch: {
    "$store.getters.selectedStudent": function () {
      this.getInfo();
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.table {
  margin-top: 10px;
}

.add-btn {
  margin-top: 10px;
}
</style>